import * as types from '@/store/mutation-types'
import apolloClient from '@/api/apollo'
import CommandsClient from '@/api/commands'

import FETCH_VEHICLE from '@/graphql/queries/CommandsDialog/FetchVehicle.graphql'

import moment from 'moment'
moment.locale('es-do')

const commandsClient = new CommandsClient()

const namespaced = true

const state = {
  vehicle: null,
  commandTransferStatus: 'SUCCESS'
}

const getters = {
  commands: state => {
    if (!state.vehicle) return []
    return state.vehicle.commands
  }
}

const mutations = {
  [types.SET_VEHICLE] (state, { vehicle }) {
    state.vehicle = vehicle
  },
  [types.SET_COMMAND_TRANSFER_STATUS] (state, { commandTransferStatus }) {
    state.commandTransferStatus = commandTransferStatus
  }
}

const actions = {
  async fetchVehicle ({ commit }, { vehicleId }) {
    const result = await apolloClient.query({
      query: FETCH_VEHICLE,
      variables: {
        vehicleId
      }
    })
    const vehicle = result.data.fetchVehicleById
    if (!vehicle) {
      throw new Error('Vehicle not found')
    }
    commit(types.SET_VEHICLE, { vehicle })
  },
  connectToCommandsServer ({ commit }) {
    return new Promise((resolve, reject) => {
      commandsClient.connect()
      commandsClient.once('connection', event => {
        console.log('Connected to commands server')
        return resolve(event)
      })
    })
  },
  sendCommand ({ commit }, { commandId, vehicleId }) {
    commit(types.SET_COMMAND_TRANSFER_STATUS, { commandTransferStatus: 'SENDING' })
    commandsClient.sendCommand({
      commandId,
      vehicleId
    })
    commandsClient.once('close', eventClose => {
      commandsClient.removeAllListeners()
      console.log('Disconnected from commands server')
    })
    commandsClient.on('transfer-update', (transferUpdate) => {
      console.log(transferUpdate.message)
      commit(types.SET_COMMAND_TRANSFER_STATUS, { commandTransferStatus: transferUpdate.status })
    })
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/commands-dialog/index.js